"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importStar(require("react"));
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const react_i18next_1 = require("react-i18next");
const events_1 = require("~/utils/events");
const MachiningServiceMetadata_1 = __importDefault(require("../BOMItemNotes/MachiningServiceMetadata/MachiningServiceMetadata"));
const BOMItemServiceNotes_scss_1 = __importDefault(require("./BOMItemServiceNotes.scss"));
function BOMItemServiceNotes({ item, service, show, updateShowHandler, y }) {
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const wrapperRef = (0, react_1.useRef)(null);
    const elementRef = (0, react_1.useRef)(null);
    const [currentMetadataList, setCurrentMetadataList] = (0, react_1.useState)([]);
    const resetMetadata = () => {
        updateShowHandler(false);
    };
    (0, useClickOutsideHandler_1.default)(wrapperRef, elementRef, resetMetadata);
    const cancelClickHandle = () => {
        resetMetadata();
    };
    const saveClickHandle = () => {
        const validMetadata = currentMetadataList.filter((metadataItem) => !!metadataItem.endFace);
        if (validMetadata.length) {
            document.body.dispatchEvent((0, events_1.updateServicesToBOMEvent)([
                {
                    machiningServiceId: service.id,
                    projectItemUUID: item.uuid[0],
                    serviceMetadata: validMetadata,
                },
            ]));
        }
        updateShowHandler(false);
    };
    const style = (0, react_1.useMemo)(() => ({
        '--y': `${y ? y + 16 : 16}px`,
    }), [y]);
    const updateMetadataHandler = (index) => (field, value) => {
        setCurrentMetadataList((prevMetadataList) => {
            const newList = [...prevMetadataList];
            if (index >= 0 && index < newList.length) {
                newList[index] = Object.assign(Object.assign({}, newList[index]), { [field]: value });
            }
            return newList;
        });
    };
    const deleteMetadataHandler = (index) => () => {
        setCurrentMetadataList((prevMetadataList) => prevMetadataList.filter((_, idx) => idx !== index));
    };
    (0, react_1.useEffect)(() => {
        var _a;
        setCurrentMetadataList(((_a = service.rawServiceMetadata) === null || _a === void 0 ? void 0 : _a.length) ? service.rawServiceMetadata : [{}]);
    }, [service.rawServiceMetadata]);
    const addMetadata = () => {
        const newMetadata = {};
        setCurrentMetadataList((prevParameters) => [...prevParameters, newMetadata]);
    };
    if (!show) {
        return null;
    }
    const itemsCanBeDeleted = currentMetadataList.length > 1;
    return (react_1.default.createElement("div", { className: BOMItemServiceNotes_scss_1.default.container, style: style, ref: wrapperRef },
        react_1.default.createElement("div", { className: BOMItemServiceNotes_scss_1.default.noteFrame },
            react_1.default.createElement("div", { ref: elementRef },
                react_1.default.createElement("div", { className: BOMItemServiceNotes_scss_1.default.header },
                    react_1.default.createElement("div", null, t(currentMetadataList.length === 0 ? 'ms.add-note' : 'ms.edit-note')),
                    react_1.default.createElement("div", { className: BOMItemServiceNotes_scss_1.default.buttonsContainer },
                        react_1.default.createElement(UI_1.Button, { onClick: cancelClickHandle }, t('bom.cancel')),
                        react_1.default.createElement(UI_1.Button, { variant: "primary", onClick: saveClickHandle }, t('bom.save')))),
                react_1.default.createElement("div", { className: BOMItemServiceNotes_scss_1.default.addNewRow },
                    react_1.default.createElement("div", { onClick: addMetadata, role: "button", tabIndex: 0 },
                        react_1.default.createElement("img", { src: assets_1.svgBasicAddNew, alt: "" }),
                        t('ms.add-row'))),
                currentMetadataList.map((serviceMetadata, idx) => (react_1.default.createElement(MachiningServiceMetadata_1.default, { item: item, serviceMetadata: serviceMetadata, onChange: updateMetadataHandler(idx), onDelete: deleteMetadataHandler(idx), canBeDeleted: itemsCanBeDeleted, 
                    // eslint-disable-next-line react/no-array-index-key
                    key: `${idx}-${serviceMetadata.endFace}-${serviceMetadata.slotNumber}-${serviceMetadata.distance}-${serviceMetadata.angle}` })))))));
}
exports.default = BOMItemServiceNotes;
